<template>
  <div class="policy-checkbox policy-checkbox_dark">
    <div class="policy-checkbox__inner">
      <input type="checkbox"
             :id="id + '-agreement'"
             value="38"
             style="opacity: 0;"
             :checked="modelValue"
             @input="$emit('update:modelValue', $event.target.checked)"
      >
      <label :for="id + '-agreement'"
             class="small-label">
        Я&nbsp;согласен(а) получать рекламные и&nbsp;информационные материалы

        <a :href="documents.newsAgreementFileRoute"
           target="_blank"
           rel="nofollow noopener noreferrer"
           class="policy-checkbox__policy-link"
        >
          рекламные и&nbsp;информационные материалы
        </a>
      </label>
    </div>
  </div>
</template>

<script>
  import NotificationIcon from "../../icons/NotificationIcon.vue";

  export default {
    name: "news-checkbox",
    components: {NotificationIcon},
    props: {
      id: {
        type: String,
        require: true,
      },
      modelValue: {
        type: Boolean,
        require: true,
      },
      showError: {
        type: Boolean,
        require: false,
      },
      documents: {
        type: Object,
        required: false
      }
    },
  }
</script>

<style scoped>

</style>